export class MathTF {
    constructor() {

    }

    public round(a: any, decimals: number) {
        let multiploDe10 = Math.pow(10, decimals);
        return Math.round(+a * multiploDe10) / multiploDe10;
    }
}